import dayjs, { Dayjs } from 'dayjs'

export const getMinDate = (): Dayjs => {
	const now = dayjs()
	const hourLimit = 13 // 13:00

	// Check if it's Friday and past 13:00
	if (now.day() === 5 && now.hour() >= hourLimit) {
		return now.add(3, 'day').startOf('day') // Monday
	}

	// Check if it's past 13:00 on a weekday
	if (now.day() >= 1 && now.day() <= 5 && now.hour() >= hourLimit) {
		return now.add(1, 'day').startOf('day')
	}

	// Otherwise, today is allowed
	return now.startOf('day')
}

export const getMaxDate = (): Dayjs => {
	return dayjs().startOf('day').add(90, 'day')
}
